export const story3 = `
byallowing{{thewarden[[33,x,x]]}}tocaptureyoumaybefree
weareboundtotheuniverseandtiedbythesouls
butneitherlifenorwisdomovercomesdarkness
itisbystandingsilentthatyoumay{{now[[33,21,x]]}}beheard
itisbyvoicingcautionthatyoumaynowproceed
itisbyhidingthatyoucanbe{{see[[33,21,x]]}}na{{s[[33,21,x]]}}what{{you[[33,21,x]]}}are
thewardengivespowertothosedeemedunworthy
{{andhasdeterminedyoudeserveallknownpowers[[33,21,78]]}}
{{praisethewarden[[33,21,78]]<<Prayer of Althan the Depraved>>}}
praisebeyourfailure
praisebeyourweakness
thewardenispleased
--Prayer of Althan the Depraved
`;
